import { isEmpty } from "lodash";
import { urlPattern } from "../../constant";

export function upgradeFirmware(data) {
  let errors = {};

  if (data?.url && !urlPattern.test(data?.url)) {
    errors.url = 'Invalid URL. Enter valid URL'
  }

  return { isValid: isEmpty(errors), errors };
}
